import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=8c85c848&scoped=true&"
import script from "./Reset.vue?vue&type=script&lang=js&"
export * from "./Reset.vue?vue&type=script&lang=js&"
import style0 from "./Reset.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Reset.vue?vue&type=style&index=1&id=8c85c848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c85c848",
  null
  
)

export default component.exports